import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import CloudDVR from "@/components/site/CloudDVR";
import Testimonials from "@/components/site/Testimonials";
import SimplePlans from "@/components/site/SimplePlans";
import Devices from "@/components/site/Devices";
import AdvertiseBanner from "@/components/site/AdvertiseBanner";
import NewsletterStrip from "@/components/site/NewsletterStrip";
import Footer from "@/components/site/Footer";
import Seo from "@/components/Seo";

const SITE_URL = process.env.REACT_APP_SITE_URL || "https://nematv.com";

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  name: "Nema TV — Desi TV Package",
  description: "Live TV from India, Bangladesh, Nepal and Pakistan on every screen. Arabic TV Package coming soon.",
  brand: { "@type": "Brand", name: "Nema TV" },
  offers: {
    "@type": "AggregateOffer",
    priceCurrency: "USD",
    lowPrice: "14.99",
    highPrice: "114.99",
    offerCount: 4,
    offers: [
      { "@type": "Offer", name: "1 Month",   price: "14.99",  priceCurrency: "USD", url: `${SITE_URL}/#pricing` },
      { "@type": "Offer", name: "3 Months",  price: "34.99",  priceCurrency: "USD", url: `${SITE_URL}/#pricing` },
      { "@type": "Offer", name: "6 Months",  price: "64.99",  priceCurrency: "USD", url: `${SITE_URL}/#pricing` },
      { "@type": "Offer", name: "12 Months", price: "114.99", priceCurrency: "USD", url: `${SITE_URL}/#pricing` },
    ],
  },
  aggregateRating: { "@type": "AggregateRating", ratingValue: "4.7", reviewCount: "1280" },
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What channels are included in the Desi TV Package?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The Nema TV Desi TV Package includes live channels from India, Bangladesh, Pakistan and Nepal — covering news, sport, drama, movies, music and kids' programming.",
      },
    },
    {
      "@type": "Question",
      name: "Which devices can I watch Nema TV on?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Watch Nema TV on Roku, Fire TV, Android, iOS, Samsung Smart TV, LG Smart TV, Apple TV and the web.",
      },
    },
    {
      "@type": "Question",
      name: "How much does the Desi TV Package cost?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Plans start at $14.99 per month. Longer 3, 6 and 12-month plans lower your effective monthly rate — 12 months works out to about $9.58/month.",
      },
    },
    {
      "@type": "Question",
      name: "When is the Arabic TV Package launching?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The Arabic TV Package is coming soon. Join the waitlist on the Arabic TV page to be first when it launches.",
      },
    },
    {
      "@type": "Question",
      name: "Can I cancel Nema TV anytime?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes — every plan is cancellable at any time from your account.",
      },
    },
  ],
};

const LandingPage = () => (
  <div className="noise-overlay relative">
    {/* Ambient bluish backdrop that fills the whole page under sections */}
    <div
      aria-hidden="true"
      data-testid="page-bluish-ambient"
      className="fixed inset-0 -z-10 pointer-events-none"
      style={{
        background:
          "radial-gradient(60% 55% at 50% 65%, rgba(24,54,138,0.55) 0%, rgba(16,34,90,0.35) 40%, rgba(5,3,10,0.85) 78%, rgba(5,3,10,1) 100%)",
      }}
    />
    <Seo
      title="Nema TV — Desi Live TV: India · Bangladesh · Pakistan · Nepal | From $14.99"
      description="Watch live Indian, Bangladeshi, Pakistani and Nepali TV anywhere in the world. Nema TV streams Desi live channels, news, sport and drama on Roku, Fire TV, Android, iOS and Web from $14.99. Arabic TV Package coming soon."
      keywords="desi live tv, indian live tv streaming, watch pakistani channels abroad, bangladeshi tv online, nepali live channels, south asian iptv, desi tv diaspora, arabic tv streaming, nema tv"
      path="/"
      schemas={[productSchema, faqSchema]}
    />
    <Navbar />
    <main>
      <Hero />
      <Devices />
      <CloudDVR />
      <Testimonials />
      <SimplePlans />
      <AdvertiseBanner />
      <NewsletterStrip />
    </main>
    <Footer />
  </div>
);

export default LandingPage;
